export const TOKEN_TYPE = "Bearer ";
export const REQUEST_HEADER_AUTH_KEY = "Authorization";
export const BACKEND_SERVER_URL = process.env.REACT_APP_BACKEND_URL;